import Tracker from '@bukalapak/tracker-js';
import isMwebUrl from 'shared_js/helpers/urlHelper/isMwebUrl';

Tracker.config({
  baseUrl: process.env.TRACKER_BASE_URL,
  dev: process.env.NODE_ENV !== 'production',
  platform: isMwebUrl() ? 'mobile' : 'desktop',
});

export default Tracker;
